import React, { useContext } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { AuthContext } from 'AuthContext';

const PrivateRoute = ({ component: Component, ...rest }) => {

  const auth = useContext(AuthContext);

  if (auth.user) {
    return (
      <Route {...rest} render={props =>
        <Component {...props} />
      }/>
    );
  } else if(auth.canLetLogin){
    return (
      <Route render={props =>
        <Redirect to={{pathname: '/login', state: {from: props.location}}}/>
      }/>
    )
  } else {
    return (
      <Route render={props =>
        <Redirect to={{pathname: '/start', state: {from: props.location}}}/>
      }/>
    )
  }
}

export default PrivateRoute;
